module.exports = __webpack_public_path__ + "img/computer_Network.09e46b6b.svg";